import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

export function initSentry(Vue, router) {
  const dsn = process.env.VUE_APP_SENTRY_DSN
  if (!dsn || process.env.NODE_ENV !== 'production') return

  Sentry.init({
    Vue,
    dsn,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: 0.1,
    logErrors: true,  // still logs to console in dev
    environment: process.env.NODE_ENV,
  })
}
